import { imageConfig } from "@/config/config";
import { useMarketData } from "@/pages/quotation/use-market-data";
import { WSContext } from "@/router/router";
import { useSignal } from "@preact-signals/safe-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

export function MarketSection() {
  const { t } = useTranslation();
  const { marketData, trendingData, topGainersData, ctmarketlist } = useMarketData();
  const activeTab = useSignal("新币");
    const getLogo = (name) => {
      let logo = "";
      for (const ctmarket of ctmarketlist) {
        if (name == ctmarket.coinname) {
          logo = imageConfig.baseImageUrl + ctmarket.logo;
          break;
        }
      }
      return logo;
    };


  return (
    <div
      className="w-full bg-[#F9F9F9] pb-10 pt-[30px] sm:pb-0 sm:pt-[60px] bg-no-repeat bg-cover"
      style={{
        backgroundImage: `url(/acendex/img/table_bg.B8l_fvpD.svg)`,
      }}
    >
      <h2 className="text-center text-[18px] font-bold leading-6 text-neutral-100 sm:text-[32px] sm:font-medium sm:leading-10">
        {t("acendex.加密货币市场行情")}
      </h2>

      <div className="container mx-auto px-10 flex flex-col lg:flex-row items-center lg:gap-6 lg:justify-between mt-10 lg:mt-[70px]">
        {/* 左侧市场数据 */}
        <div className="w-full rounded-[30px] px-4 sm:min-h-[500px] sm:w-[710px] sm:bg-white sm:p-0 sm:shadow-[0_0_30px_0_rgba(123,88,197,0.15)]">
          {/* 桌面端标签 */}
          <div className="hidden items-center justify-between px-8 pb-[14px] pt-6 sm:flex">
            {/* <div className="hidden rounded-[30px] border border-neutral-200 bg-[#F9F9F9] sm:flex">
              {tabs.map((tab) => (
                <div
                  key={tab}
                  className={`flex cursor-pointer items-center rounded-full px-5 py-1.5 text-[12px] font-medium leading-[18px] text-neutral-100 ${
                    activeTab.value === tab ? "bg-white shadow-card" : ""
                  }`}
                  onClick={() => (activeTab.value = tab)}
                >
                  <span>{tab}</span>
                </div>
              ))}
            </div> */}
            <div />
            <a
              className="ml-2.5 text-sm text-primary"
              target="_blank"
              href="/quotation"
              rel="noopener noreferrer"
            >
              {t("acendex.查看全部")}
            </a>
          </div>

          {/* 表头 */}
          <div className="hidden px-[22px] pb-6 text-xs text-neutral-500 sm:block">
            <div className="py-[10px]">
              <div className="flex h-full items-center px-[10px]">
                <div className="group box-border flex flex-[3] cursor-pointer items-center text-xs">
                  <div className="label">{t("acendex.交易对")}</div>
                  <i className="h-3 w-3 rotate-180 text-xs leading-3 text-neutral-400"></i>
                </div>
                <div className="group box-border flex flex-[1.5] cursor-pointer items-center text-xs">
                  <div>{t("acendex.最新成交价(USD)")}</div>
                  <i className="h-3 w-3 rotate-180 text-xs leading-3 text-neutral-400"></i>
                </div>
                <div className="group box-border flex flex-1 cursor-pointer items-center text-xs">
                  <div>{t("acendex.24H涨跌幅")}</div>
                  <i className="h-3 w-3 rotate-180 text-xs leading-3 text-neutral-400"></i>
                </div>
                <div className="flex-[1]"></div>
              </div>
            </div>

            {/* 数据行 */}
            <div className="max-h-[364px] overflow-y-auto">
              {marketData.map((item) => (
                <div
                  key={item.id}
                  className="group mb-1 cursor-pointer rounded-[30px] px-[10px] hover:bg-neutral-800"
                >
                  <div className="flex">
                    <div className="flex h-[42px] flex-[3] items-center leading-5">
                      <div className="flex items-center justify-center w-6 h-6 rounded-full bg-neutral-900">
                        <img
                          src={getLogo(item.id)}
                          className="w-5 h-5 rounded-full"
                          alt={item.id}
                          loading="lazy"
                        />
                      </div>
                      <div className="ml-2.5 flex justify-between">
                        <div className="font-bold text-neutral-100">
                          {item.id.toUpperCase()}
                        </div>
                        <div className="ml-0.5 text-neutral-500">
                          {item.name}
                        </div>
                      </div>
                    </div>
                    <div className="flex h-[42px] flex-[1.5] items-center">
                      <div className="text-xs font-bold text-neutral-100">
                        {item.price}
                      </div>
                    </div>
                    <div className="flex h-[42px] flex-1 items-center">
                      <div
                        className={`text-xs font-bold ${
                          item.change.startsWith("+")
                            ? "text-success"
                            : item.change.startsWith("-")
                            ? "text-danger"
                            : "text-neutral-400"
                        }`}
                      >
                        {item.change}
                      </div>
                    </div>
                    <div className="flex h-[42px] flex-1 items-center justify-end">
                      <div className="flex h-[30px] w-[100px] items-center justify-center rounded-full border border-primary text-sm font-bold leading-4 text-primary group-hover:border-none group-hover:bg-primary group-hover:text-white">
                        {t("acendex.交易")}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 移动端数据 */}
          <div className="sm:hidden">
            {marketData.slice(0, 5).map((item) => (
              <div
                key={item.id}
                className="flex items-center justify-between p-4 border-b border-neutral-100"
              >
                <div className="flex items-center">
                  <div className="flex items-center justify-center w-8 h-8 rounded-full bg-neutral-800">
                    <img
                      src={getLogo(item.id)}
                      className="w-6 h-6 rounded-full"
                      alt={item.id}
                      loading="lazy"
                    />
                  </div>
                  <div className="ml-3">
                    <div className="font-bold text-neutral-100">
                      {item.id.toUpperCase()}
                    </div>
                    <div className="text-xs text-neutral-500">{item.name}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-bold text-neutral-100">{item.price}</div>
                  <div
                    className={`text-xs font-bold ${
                      item.change.startsWith("+")
                        ? "text-success"
                        : item.change.startsWith("-")
                        ? "text-danger"
                        : "text-neutral-400"
                    }`}
                  >
                    {item.change}
                  </div>
                </div>
              </div>
            ))}
            <div className="flex justify-center mt-4">
              <a className="text-sm text-primary" href="/quotation">
                {t("acendex.查看全部")}
              </a>
            </div>
          </div>
        </div>

        {/* 右侧排行榜 */}
        <div className="mt-6 sm:mt-0 w-full sm:w-[460px] px-4 sm:px-0">
          {/* 24小时成交量 */}
          <div className="rounded-[30px] bg-white p-6 shadow-[0_0_30px_0_rgba(123,88,197,0.15)] mb-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-neutral-100">
                {t("acendex.24H成交量")}
              </h3>
              <a className="text-sm text-primary" href="/quotation">
                {t("acendex.更多")}
              </a>
            </div>
            <div className="space-y-4">
              <div className="flex items-center text-xs text-neutral-500 pb-2">
                <div className="w-1/3">{t("acendex.交易对")}</div>
                <div className="w-1/3 text-right">
                  {t("acendex.最新成交价(USD)")}
                </div>
                <div className="w-1/3 text-right">{t("acendex.24H涨跌幅")}</div>
              </div>
              {trendingData.map((item) => (
                <div key={item.id} className="flex items-center">
                  <div className="w-1/3 flex items-center">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-neutral-900 mr-2">
                      <img
                        src={getLogo(item.id)}
                        className="w-5 h-5 rounded-full"
                        alt={item.id}
                        loading="lazy"
                      />
                    </div>
                    <div className="font-bold text-neutral-100">
                      {item.id.toUpperCase()}
                    </div>
                  </div>
                  <div className="w-1/3 text-right font-medium text-neutral-100">
                    {item.price}
                  </div>
                  <div
                    className={`w-1/3 text-right font-medium ${
                      item.change.startsWith("+")
                        ? "text-success"
                        : item.change.startsWith("-")
                        ? "text-danger"
                        : "text-neutral-400"
                    }`}
                  >
                    {item.change}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 24小时涨幅榜 */}
          <div className="rounded-[30px] bg-white p-6 shadow-[0_0_30px_0_rgba(123,88,197,0.15)]">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-neutral-100">
                {t("acendex.24H涨跌幅")}
              </h3>
              <a className="text-sm text-primary" href="/quotation">
                {t("acendex.更多")}
              </a>
            </div>
            <div className="space-y-4">
              <div className="flex items-center text-xs text-neutral-500 pb-2">
                <div className="w-1/3">{t("acendex.交易对")}</div>
                <div className="w-1/3 text-right">
                  {t("acendex.最新成交价(USD)")}
                </div>
                <div className="w-1/3 text-right">{t("acendex.24H涨跌幅")}</div>
              </div>
              {topGainersData.map((item) => (
                <div key={item.id} className="flex items-center">
                  <div className="w-1/3 flex items-center">
                    <div className="flex items-center justify-center w-6 h-6 rounded-full bg-neutral-900 mr-2">
                      <img
                        src={getLogo(item.id)}
                        className="w-5 h-5 rounded-full"
                        alt={item.id}
                        loading="lazy"
                      />
                    </div>
                    <div className="font-bold text-neutral-100">
                      {item.id.toUpperCase()}
                    </div>
                  </div>
                  <div className="w-1/3 text-right font-medium text-neutral-100">
                    {item.price}
                  </div>
                  <div
                    className={`w-1/3 text-right font-medium ${
                      item.change.startsWith("+")
                        ? "text-success"
                        : item.change.startsWith("-")
                        ? "text-danger"
                        : "text-neutral-400"
                    }`}
                  >
                    {item.change}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
